import React from "react";

interface VariantPickerProps {
  variants: {
    onClick: () => void;
    color: string;
    active?: boolean;
  }[];
}

export const VariantPicker = ({ variants }: VariantPickerProps) => {
  return (
    <div className="flex gap-0.5">
      {variants.map((variant, i) => (
        <button
          key={i}
          className={`w-6 h-6 rounded-full border p-1 ${variant.active ?  "border-neutrals-black" : "border-transparent" }`}
          onClick={variant.onClick}
        >
          <div className="w-full h-full rounded-full" style={{ backgroundColor: variant.color }}>
            <div />
          </div>
        </button>
      ))}
    </div>
  );
};
